export const capitilizeFirstAlphabet = (str) => {

  return  str.replace(/^./, str[0].toUpperCase());
}